import React from 'react';
import css from 'styled-jsx/css';
import Container from '~/components/Container';
import I18nLink from '~/components/I18nLink';
import config from '~/config';
import themeVariables from '~/shared/themeVariables';
import { SERVICE_TYPES } from '~/utils/constants';

const SECTION_IMAGE_BY_SERVICE_TYPE = {
  [SERVICE_TYPES.PHOTO_AC]: `${config.staticPrefix}/static/images/submission-guideline-page/mobile-view/rejected-section-image-photo-ac.png`,
  [SERVICE_TYPES.ILLUST_AC]: `${config.staticPrefix}/static/images/submission-guideline-page/mobile-view/rejected-section-image-illust-ac.png`,
};

const MobileView = ({ t, lng }) => {
  const faqLink =
    lng === 'tw'
      ? 'https://global.help.freebie-ac.jp/tw/'
      : 'https://global.help.freebie-ac.jp';

  return (
    <Container
      className={containerClassName}
      contentClassName={contentClassName}
    >
      <img
        className="section-img lazyload"
        data-srcset={SECTION_IMAGE_BY_SERVICE_TYPE[config.serviceType]}
      />
      <div className="rejected-content">
        <h2 className="title">{t('rejected_content')}</h2>
        {config.isPhotoAC() ? (
          <div className="description">
            <div className="rejected-content-description">
              {t('photo_rejected_content_description')}
            </div>
            <div className="list-item">
              {t('photo_rejected_content_item_1')}
            </div>
            <div className="list-item">
              {t('photo_rejected_content_item_2')}
            </div>
            <div className="list-item">
              {t('photo_rejected_content_item_3')}
            </div>
            <div
              className="list-item"
              dangerouslySetInnerHTML={{
                __html: t('photo_rejected_content_item_4'),
              }}
            />
          </div>
        ) : (
          <div className="description">
            <div className="rejected-content-description">
              {t('ill_rejected_content_description')}
            </div>
            <div className="list-item">{t('ill_rejected_content_item_1')}</div>
            <div className="list-item">{t('ill_rejected_content_item_2')}</div>
            <div className="list-item">{t('ill_rejected_content_item_3')}</div>
            <div className="list-item">{t('ill_rejected_content_item_4')}</div>
            <div
              className="list-item"
              dangerouslySetInnerHTML={{
                __html: t('ill_rejected_content_item_5'),
              }}
            />
          </div>
        )}
        <div className="links-section">
          <a
            className="ac-link link-help-page"
            href={faqLink}
            target="_blank"
            rel="noreferrer"
          >
            {t('go_to_help_page')}
          </a>
          {/* <I18nLink href="/sell-your-content">
            <a className="ac-link link-home-page">{t('home')}</a>
          </I18nLink> */}
        </div>
      </div>
      <img
        className="img-wiggle lazyload"
        data-srcset={`${config.staticPrefix}/static/images/submission-guideline-page/mobile-view/wiggle-2.png`}
      />
      <style jsx>{styles}</style>
      {containerStyles}
      {contentStyles}
    </Container>
  );
};

const { className: containerClassName, styles: containerStyles } = css.resolve`
  width: 100%;
  background: #f8f9fa;
  padding-top: 24px;
`;

const { className: contentClassName, styles: contentStyles } = css.resolve`
  display: flex;
  flex-direction: column;
`;

const styles = css`
  .section-img {
    width: 100%;
  }

  .rejected-content {
    display: flex;
    flex-direction: column;
    margin-top: 24px;
  }

  .title {
    font-size: 24px;
    font-weight: 600;
    padding: 0;
    margin: 0;
  }

  .description {
    margin-top: 32px;
  }
  .list-item {
    margin-top: 8px;
  }

  .links-section {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-top: 24px;
  }

  .img-wiggle {
    width: 100%;
    margin-top: 24px;
  }
`;

export default MobileView;
